var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistorija(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18125_12130",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18125_12130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4V10.1923L9.5 9L11.5 10.1923V4H7.5ZM17.5 21.6923C16.3858 21.6923 15.4407 21.3042 14.6645 20.528C13.8882 19.7517 13.5 18.8064 13.5 17.6923C13.5 16.5783 13.8913 15.6331 14.674 14.8568C15.4567 14.0804 16.4307 13.6923 17.5962 13.6923C18.6591 13.6923 19.5754 14.0804 20.3453 14.8568C21.1151 15.6331 21.5 16.5783 21.5 17.6923C21.5 18.8064 21.1118 19.7517 20.3355 20.528C19.5593 21.3042 18.6142 21.6923 17.5 21.6923ZM16.6345 19.577L19.3655 17.6538L16.6345 15.7308V19.577ZM11.5 17.6908C11.5 18.2839 11.5837 18.8594 11.751 19.4173C11.9183 19.9749 12.1616 20.5025 12.4808 21H5.6155C5.17117 21 4.79083 20.8418 4.4745 20.5255C4.15817 20.2092 4 19.8288 4 19.3845V4.6155C4 4.17117 4.15817 3.79083 4.4745 3.4745C4.79083 3.15817 5.17117 3 5.6155 3H16.3845C16.8288 3 17.2092 3.15817 17.5255 3.4745C17.8418 3.79083 18 4.17117 18 4.6155V11.723C17.9325 11.7192 17.8649 11.7163 17.7973 11.7145C17.7298 11.7125 17.6622 11.7115 17.5947 11.7115C15.9081 11.7115 14.4707 12.2923 13.2825 13.4538C12.0942 14.6151 11.5 16.0274 11.5 17.6908Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistorija);
export default __webpack_public_path__ + "static/media/historija.f38d1fb357f1f67feb37e889b634ccf8.svg";
export { ForwardRef as ReactComponent };